import { Component, Input, OnInit } from '@angular/core';
import { SsoPaymentConfig } from './sso-payment.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'sso-payment',
  styleUrls: ['./sso-payment.component.scss'],
  templateUrl: './sso-payment.component.html',
})
export class SsoPaymentComponent implements OnInit {
  @Input() config: SsoPaymentConfig;

  ngOnInit(): void {
    const [config] = checkInputsForText([this.config]);

    this.config = config;

    if (!this.config) throw new Error('Missing SSO payment config');
  }
}
